export default class ServiceTags extends React.Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.serviceBlocks = this.serviceBlocks.bind(this);
    this.serviceBlock = this.serviceBlock.bind(this);
    this.tagsToRender = this.tagsToRender.bind(this);
    this._isChecked = this._isChecked.bind(this);
    this.state = {};
  }

  _isChecked(id) {
    return (this.props.value || []).includes(String(id));
  }

  handleChange(event) {
    let newValue = [...(this.props.value || [])];

    if (event.target.checked) {
      newValue.push(event.target.value);
    } else {
      newValue = newValue.filter((v) => v != event.target.value);
    }

    return this.props.filter(this.props.condition_param, newValue.length === 0 ? false : newValue);
  }

  serviceBlock(service_tag, i) {
    return (
      <div
        className='mdc-form-field filter-row__check'
        key={i}
        onClick={() => {
          $(`.input_campServiceTags${service_tag.main_id}`).trigger('click');
        }}
      >
        <div className='mdc-checkbox'>
          <input
            className={`mdc-checkbox__native-control input_campServiceTags${service_tag.main_id}`}
            type='checkbox'
            onClick={(event) => {
              event.stopPropagation();
            }}
            onChange={this.handleChange}
            value={service_tag.id}
            checked={this._isChecked(service_tag.id)}
            data-id={service_tag.id}
          />

          <div className='mdc-checkbox__background'>
            <svg className='mdc-checkbox__checkmark' viewBox='0 0 24 24'>
              <path className='mdc-checkbox__checkmark-path' fill='none' d='M1.73,12.91 8.1,19.28 22.79,4.59' />
            </svg>

            <div className='mdc-checkbox__mixedmark' />
          </div>
        </div>

        <label className='mdc-checkbox__label'>
          {service_tag.name}&nbsp;&nbsp;
          {this.props.counts && !this._isChecked(service_tag.id) && (
            <span className={'mdc-checkbox__label-count'}>{this.props.counts[service_tag.id] ?? 0}</span>
          )}
        </label>
      </div>
    );
  }

  tagsToRender() {
    if (this.props.counts) {
      return this.props.campServiceTags.filter((item) => this._isChecked(item.id) || this.props.counts[item.id] > 0);
    } else {
      return this.props.campServiceTags;
    }
  }

  serviceBlocks() {
    return this.tagsToRender().map((service_tag, i) => {
      if (!this.props.show_chosen || this._isChecked(service_tag.id)) {
        return this.serviceBlock(service_tag, i);
      } else return null;
    });
  }

  render() {
    if (this.props.show_chosen && (this.props.value || []).length === 0) {
      return null;
    }
    return (
      <div className='filter-row'>
        <div className='filter-row__title'>{this.props.service_name}</div>

        {this.serviceBlocks()}
      </div>
    );
  }
}
